// extracted by mini-css-extract-plugin
export default {"termoUso":"TermoUso_termoUso__x-tQ2"};